import "core-js/modules/es.array.concat.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useStore } from "../../../utils";
import { useEffect } from "react";
import { observer } from "mobx-react-lite";

function DataLayer(props) {
  var _store$user, _store$user$analytics, _store$common, _store$common$appAttr, _store$common$appAttr2, _store$common$appAttr3;

  var store = useStore();
  var dataLayerJSON = (_store$user = store.user) === null || _store$user === void 0 ? void 0 : (_store$user$analytics = _store$user.analyticsModel) === null || _store$user$analytics === void 0 ? void 0 : _store$user$analytics.dataLayerJSON;
  var brandname = store === null || store === void 0 ? void 0 : (_store$common = store.common) === null || _store$common === void 0 ? void 0 : (_store$common$appAttr = _store$common.appAttributes) === null || _store$common$appAttr === void 0 ? void 0 : (_store$common$appAttr2 = _store$common$appAttr.concept) === null || _store$common$appAttr2 === void 0 ? void 0 : (_store$common$appAttr3 = _store$common$appAttr2.conceptCode) === null || _store$common$appAttr3 === void 0 ? void 0 : _store$common$appAttr3.toLowerCase();
  useEffect(function () {
    // To set page Name and title if provided
    if (props !== null && props !== void 0 && props.analyticsData) {
      var _store$user2, _store$user2$analytic;

      store === null || store === void 0 ? void 0 : (_store$user2 = store.user) === null || _store$user2 === void 0 ? void 0 : (_store$user2$analytic = _store$user2.analyticsModel) === null || _store$user2$analytic === void 0 ? void 0 : _store$user2$analytic.setPageAnalyticsDetails({
        pageName: "".concat(brandname, "|").concat(props.analyticsData.pageName),
        pageType: "".concat(brandname, "|").concat(props.analyticsData.pageType)
      });
    }

    try {
      window.digitalData = dataLayerJSON;
    } catch (error) {
      window.digitalData = "{}";
    }
  }, [JSON.stringify(dataLayerJSON), props === null || props === void 0 ? void 0 : props.analyticsData]);
  return /*#__PURE__*/_jsx(_Fragment, {});
}

export default observer(DataLayer);